import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';

/**
 * The path of the Social detail of one social post: `/social/post/:id`. The id is the social post
 * id (`SerializedSocialPost.id`, the Calendar `socialPostId`), never the uuid of a scheduled post.
 */
export function socialPostPath(socialPostId: number): string {
  return `/${SMLRouteNames.social}/post/${socialPostId}`;
}
